const listFormat = (locale, list) => {
  const formatter = Intl.ListFormat
    ? new Intl.ListFormat(locale, { style: 'long', type: 'conjunction' })
    : { format: l => l.join(', ') };
  return formatter.format(list);
};

export default listFormat;
